<template>
  <div class="box box--default">
    <div>
      <h4 class="mrgt0 mrgb--">
        {{ gettext('Estimation de votre plein') }}
      </h4>

      <div class="text-huge mrgb--">
        <span class="text-brand text-bold">
          {{ cost }}
        </span>
        <span class="text-muted">
          <small>{{ gettext('par an') }}¹</small>
        </span>
      </div>

      <div>
        {{
          interpolate(
            gettext(
              'Sur la base d’une consommation de %s kg de gaz naturel-biogaz sur le réseau Holdinova.'
            ),
            [formatNumber(mobilityTotal)]
          )
        }}
      </div>
    </div>

    <div class="box__footer pdgv- text-muted text-small mrgt-">
      {{
        gettext(
          'Le gaz naturel carburant contient d’office 20% de biogaz, sans surcoût pour le client.'
        )
      }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { GNC_PRICE_PER_KG } from '@/config/simulation';
import { addVAT, formatCurrency, formatNumber } from '@/helpers/utils';
import { useSimulation } from '@/composables/useSimulation';

const { mobilityTotal } = useSimulation();

const cost = computed(() => {
  return formatCurrency(addVAT(mobilityTotal.value * GNC_PRICE_PER_KG));
});
</script>
